import { createService } from '@/helpers/hasura'
import _countWhere from '@/helpers/hasura/count-where'

import gql from 'graphql-tag'
import moment from 'moment'
import api from '@/helpers/api'
import isEmpty from 'lodash/isEmpty'
import {
  WebFormFragment,
  AddressFragment,
  FileFragment,
  ItemFragment
} from '@/helpers/api/fragments'

const output = `
  ...WebForm
  customer {
    company_name
  }
  user {
    name
  }
  file {
    ...File
  }
  shipping_address{
    ...Address
  }
  item{
    ...Item
  }
`
const fragments = gql`
  ${WebFormFragment}
  ${AddressFragment}
  ${FileFragment}
  ${ItemFragment}
`

const allowedFields = [
  'customer_account_id',
  'user_id',
  'reference',
  'shipping_address_id',
  'comments',
  'quantity',
  'type',
  'form_data',
  'is_submitted',
  'submitted_at',
  'file_id',
  'item_id'
]

export default config => {
  const { client } = config

  const service = createService({
    ...config,
    table: 'web_form',
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    defaultOrderBy: [{ submitted_at: 'desc' }],
    defaultSearchBy: [
      'reference',
      { item: ['code', 'short_description'] },
      { shipping_address: ['city', 'company_name'] },
      { customer: ['company_name'] },
      { file: ['file_name'] }
    ],
    allowedFields,
    uniqueFields: []
  })

  return {
    ...service,
    countWhere: _countWhere({
      ...config,
      table: 'web_form'
    }),
    cancel: async payload => {
      const {
        id = () => {
          throw new Error("webForms.cancel: 'id' is required")
        }
      } = payload

      const mutation = gql`
        mutation cancelWebForm($id: uuid!) {
          item: update_web_form_by_pk(
            pk_columns: { id: $id }
            _set: { status: cancelled }
          ) {
            ${output}
          }
        }
        ${fragments}
      `

      const { data } = await client.mutate({
        mutation,
        variables: { id }
      })

      return data.item
    },
    isUniqueReference: async payload => {
      const {
        reference = () => {
          throw new Error("modelTypeStats: 'reference' is required")
        }
      } = payload

      const query = gql`
        query stats($reference: String!) {
          web_form_aggregate(where: { reference: { _ilike: $reference } }) {
            aggregate {
              count
            }
          }
        }
      `

      const { data } = await client.query({
        query,
        variables: {
          reference
        }
      })

      return data.web_form_aggregate.aggregate.count === 0
    },
    webFormByUserIdSubscription: payload => {
      /*const {
        user_id = () => {
          throw new Error("webFormByUserIdSubscription: 'user_id' is required")
        }
      } = payload*/

      const query = gql`
        subscription items{
          items: web_form(where : { is_submitted: { _eq: false} }){
            ${output}
          }
        }
        ${fragments}
      `

      const observer = client.subscribe({
        query
        /*         variables: {
          userId: user_id
        } */
      })

      return observer
    },
    fetchMinStatsYear: async payload => {
      const query = gql`
        query {
          items: vw_webform_stats_aggregate {
            aggregate {
              min {
                year
              }
            }
          }
        }
      `
      const { data } = await client.query({
        query
      })

      return data.items.aggregate.min.year
    },
    fetchModelTypeStats: async payload => {
      const {
        year = () => {
          throw new Error("modelTypeStats: 'year' is required")
        }
      } = payload

      const query = gql`
        query stats($year: float8!) {
          items: vw_webform_stats(where: { year: { _eq: $year } }) {
            model_type
            month
            year
            week
            quantity
            type
          }
        }
      `
      const { data } = await client.query({
        query,
        variables: {
          year: year
        }
      })

      return data.items
    }
  }
}
